export default __webpack_public_path__ + "static/media/UloadIcon.fcd7d151.svg";